import React, { useState, useEffect } from 'react';
import TranscriptEmbedded from './transcript';
import getFirebase from '../../utils/firebase.js';


interface EmbeddedPageProps {
  id: string;
  asset: string;
}

const Page = (props:EmbeddedPageProps) => {
  const { id, asset } = props;
  
  useEffect(() => {
    const firebase = getFirebase();
  }, []);
  

  return (
    <div>
        <TranscriptEmbedded id={id} asset={asset}/>
    </div>
  );
};

export default Page;
